import Vue from 'vue'
import Router from 'vue-router'
import StaffLoginPage from '@/components/page/auth/StaffLoginPage'
import StaffPasswordChangePage from '@/components/page/auth/StaffPasswordChangePage'
import CallCenterLoginPage from '@/components/page/auth/CallCenterLoginPage'
import BranchOfficeLoginPage from '@/components/page/auth/BranchOfficeLoginPage'
import MainOfficeLoginPage from '@/components/page/auth/MainOfficeLoginPage'
import ShopStaffMasterPage from '@/components/page/ShopStaffMasterPage'
import ShopHomePage from '@/components/page/ShopHomePage'
import ShopJobPositionMasterPage from '@/components/page/ShopJobPositionMasterPage'
import ShopSkillAttributeMasterPage from '@/components/page/ShopSkillAttributeMasterPage'
import ShopJobTypeMasterPage from '@/components/page/ShopJobTypeMasterPage'
import ShopSearchPage from '@/components/page/ShopSearchPage'
import ShopAnotherSearchPage from '@/components/page/ShopAnotherSearchPage'
import ReservationListPage from '@/components/page/ReservationListPage'
import ShopWorkSchedulePage from '@/components/page/ShopWorkSchedulePage'
import MainOfficeHomePage from '@/components/page/MainOfficeHomePage'
import MainOfficeSkillAttributeMasterPage from '@/components/page/MainOfficeSkillAttributeMasterPage'
import MainOfficeJobTypeMasterPage from '@/components/page/MainOfficeJobTypeMasterPage'
import MainOfficeJobPositionMasterPage from '@/components/page/MainOfficeJobPositionMasterPage'
import MainOfficeTodoTypeMasterPage from '@/components/page/MainOfficeTodoTypeMasterPage'
import MainOfficeShopMasterPage from '@/components/page/MainOfficeShopMasterPage'
import MainOfficeExportDataPage from '@/components/page/MainOfficeExportDataPage'
import ShopTodoListDownloadPage from '@/components/page/ShopTodoListDownloadPage'
import ShopImportWorkSchedulePage from '@/components/page/ShopImportWorkSchedulePage'
import MainOfficeImportWorkSchedulePage from '@/components/page/MainOfficeImportWorkSchedulePage'
import DigitalSignagePage from '@/components/page/DigitalSignagePage'
import ShopSignageFileImportPage from '@/components/page/ShopSignageFileImportPage'
import CgtManageLoginPage from '@/components/page/auth/CgtManageLoginPage'
import CgtManageHomePage from '@/components/page/CgtManageHomePage'
import CgtManageSkillAttributeMasterPage from '@/components/page/CgtManageSkillAttributeMasterPage'
import CgtManageJobTypeMasterPage from '@/components/page/CgtManageJobTypeMasterPage'
import CgtManageJobPositionMasterPage from '@/components/page/CgtManageJobPositionMasterPage'
import CgtManageTodoTypeMasterPage from '@/components/page/CgtManageTodoTypeMasterPage'
import CgtManageShopMasterPage from '@/components/page/CgtManageShopMasterPage'
import CgtManageStaffMasterPage from '@/components/page/CgtManageStaffMasterPage'
import CgtManageImportShopPwPage from '@/components/page/CgtManageImportShopPwPage'
import CgtManageImportCallcenterPwPage from '@/components/page/CgtManageImportCallcenterPwPage'
import CgtManageImportMainOfficePwPage from '@/components/page/CgtManageImportMainOfficePwPage'
import CgtManageImportBranchOfficePwPage from '@/components/page/CgtManageImportBranchOfficePwPage'
import CgtManageSystemSettingPage from '@/components/page/CgtManageSystemSettingPage'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		// ログイン系
		{
			path: '/',
			name: 'StaffLoginPage',
			component: StaffLoginPage
		},
		{
			path: '/staff/login',
			name: 'StaffLoginPage',
			component: StaffLoginPage
		},
		{
			path: '/staff/password_change',
			name: 'StaffPasswordChangePage',
			component: StaffPasswordChangePage
		},
		{
			path: '/call_center/login',
			name: 'CallCenterLoginPage',
			component: CallCenterLoginPage
		},
		{
			path: '/branch_office/login',
			name: 'BranchOfficeLoginPage',
			component: BranchOfficeLoginPage
		},
		{
			path: '/main_office/login',
			name: 'MainOfficeLoginPage',
			component: MainOfficeLoginPage
		},
		{
			path: '/cgt_manage/login',
			name: 'CgtManageLoginPage',
			component: CgtManageLoginPage
		},
		// 本部系
		{
			path: '/main_office',
			name: 'MainOfficeHomePage',
			component: MainOfficeHomePage
		},
		{
			path: '/main_office/master/job_type',
			name: 'MainOfficeJobTypeMasterPage',
			component: MainOfficeJobTypeMasterPage
		},
		{
			path: '/main_office/master/skill_attribute',
			name: 'MainOfficeSkillAttributeMasterPage',
			component: MainOfficeSkillAttributeMasterPage
		},
		{
			path: '/main_office/master/job_position',
			name: 'MainOfficeJobPositionMasterPage',
			component: MainOfficeJobPositionMasterPage
		},
		{
			path: '/main_office/master/todo_type',
			name: 'MainOfficeTodoTypeMasterPage',
			component: MainOfficeTodoTypeMasterPage
		},
		{
			path: '/main_office/master/shop',
			name: 'MainOfficeShopMasterPage',
			component: MainOfficeShopMasterPage
		},
		{
			path: '/main_office/export/data',
			name: 'MainOfficeExportDataPage',
			component: MainOfficeExportDataPage
		},
		{
			path: '/main_office/import_work_schedule',
			name: 'ShopImportWorkSchedulePage',
			component: MainOfficeImportWorkSchedulePage
		},
		// 店舗系
		{
			path: '/shop',
			name: 'ShopHomePage',
			component: ShopHomePage
		},
		{
			path: '/shop/master/job_position',
			name: 'ShopJobPositionMasterPage',
			component: ShopJobPositionMasterPage
		},
		{
			path: '/shop/master/job_type',
			name: 'ShopJobTypeMasterPage',
			component: ShopJobTypeMasterPage
		},
		{
			path: '/shop/master/skill_attribute',
			name: 'ShopSkillAttributeMasterPage',
			component: ShopSkillAttributeMasterPage
		},
		{
			path: '/shop/master/staff',
			name: 'ShopStaffMasterPage',
			component: ShopStaffMasterPage
		},
		{
			path: '/shop/work_schedule',
			name: 'ShopWorkSchedulePage',
			component: ShopWorkSchedulePage
		},
		{
			path: '/shop/work_schedule/:date',
			name: 'ShopWorkSchedulePage',
			component: ShopWorkSchedulePage
		},
		{
			path: '/shop/todo_download/',
			name: 'ShopTodoListDownloadPage',
			component: ShopTodoListDownloadPage
		},
		{
			path: '/shop/import_work_schedule/',
			name: 'ShopImportWorkSchedulePage',
			component: ShopImportWorkSchedulePage
		},
		{
			path: '/shop/import_signage_file/',
			name: 'ShopSignageFileImportPage',
			component: ShopSignageFileImportPage
		},
		// 共通
		{
			path: '/reservation_list/:shop_id',
			name: 'ReservationListPage',
			component: ReservationListPage
		},
		{
			path: '/reservation_list/:shop_id/:date',
			name: 'ReservationListPage',
			component: ReservationListPage
		},
		{
			path: '/shop_search',
			name: 'ShopSearchPage',
			component: ShopSearchPage
		},
		{
			path: '/shop_another_search',
			name: 'ShopAnotherSearchPage',
			component: ShopAnotherSearchPage
		},
		{
			path: '/digital_signage',
			name: 'DigitalSignagePage',
			component: DigitalSignagePage
		},
		// コギト管理系
		{
			path: '/cgt_manage',
			name: 'CgtManageHomePage',
			component: CgtManageHomePage
		},
		{
			path: '/cgt_manage/master/job_type',
			name: 'CgtManageJobTypeMasterPage',
			component: CgtManageJobTypeMasterPage
		},
		{
			path: '/cgt_manage/master/skill_attribute',
			name: 'CgtManageSkillAttributeMasterPage',
			component: CgtManageSkillAttributeMasterPage
		},
		{
			path: '/cgt_manage/master/job_position',
			name: 'CgtManageJobPositionMasterPage',
			component: CgtManageJobPositionMasterPage
		},
		{
			path: '/cgt_manage/master/todo_type',
			name: 'CgtManageTodoTypeMasterPage',
			component: CgtManageTodoTypeMasterPage
		},
		{
			path: '/cgt_manage/master/shop',
			name: 'CgtManageShopMasterPage',
			component: CgtManageShopMasterPage
		},
		{
			path: '/cgt_manage/master/staff',
			name: 'CgtManageStaffMasterPage',
			component: CgtManageStaffMasterPage
		},
		{
			path: '/cgt_manage/master/import_shop_pw',
			name: 'CgtManageImportShopPwPage',
			component: CgtManageImportShopPwPage
		},
		{
			path: '/cgt_manage/master/import_callcenter_pw',
			name: 'CgtManageImportCallcenterPwPage',
			component: CgtManageImportCallcenterPwPage
		},
		{
			path: '/cgt_manage/master/import_main_office_pw',
			name: 'CgtManageImportMainOfficePwPage',
			component: CgtManageImportMainOfficePwPage
		},
		{
			path: '/cgt_manage/master/import_branch_office_pw',
			name: 'CgtManageImportBranchOfficePwPage',
			component: CgtManageImportBranchOfficePwPage
		},
		{
			path: '/cgt_manage/master/system_setting',
			name: 'CgtManageSystemSettingPage',
			component: CgtManageSystemSettingPage
		}
	],
	scrollBehavior (to, from, savedPosition) {
		if (to.name == 'ReservationListPage') {
			location.reload()
		}
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js